import React from 'react';
import { Link } from 'react-router-dom';

export const LandingStartAction = () => (
  <div className="care-landing-cta">
    <Link className="care-landing-button" to="/login">
      Start for free
    </Link>
    <p className="care-landing-fineprint">Free to start · No credit card required</p>
  </div>
);

export const LandingTimelineImage = () => (
  <div className="care-landing-screen-crop care-landing-timeline-screen">
    <img
      src="/media/landing/timeline-reference.png"
      alt="Timeline care notes with organized details and original wording"
      loading="lazy"
    />
  </div>
);

export const LandingCircleImage = () => (
  <div className="care-landing-screen-crop care-landing-circle-screen">
    <img
      src="/media/landing/circle-reference.png"
      alt="Care Partner access, showing what a trusted family member can manage"
      loading="lazy"
    />
  </div>
);

const LandingProductSteps = () => (
  <>
    <section className="care-landing-section care-landing-container">
      <div className="care-landing-section-heading">
        <span className="care-landing-eyebrow">When you have a question</span>
        <h2>Find an answer you can trace back.</h2>
      </div>
      <div className="care-landing-feature-grid">
        <div className="care-landing-feature-copy">
          <p>
            “What progress have we seen since the medication change?” “When does she sleep best?” Lifelog
            searches your saved history and answers with the entries it drew from, so you can bring real dates
            and details to the appointment instead of a best guess.
          </p>
        </div>
        <img
          className="care-landing-product-screen"
          src="/media/landing/ask.png"
          alt="Lifelog answering a question about care progress with numbered sources"
          loading="lazy"
        />
      </div>
    </section>
  </>
);

export default LandingProductSteps;
